export const GET_DASHBOARDS = "GET_DASHBOARDS";
export const RESET_DASHBOARD = "RESET_DASHBOARD";
export const ERROR_DASHBOARD = "ERROR_DASHBOARD";
